import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
	setMenuTopIndex,
	setMenuLeftContent,
	setMenuLeftIndex,
	setMenuLeftItemIndex,
} from "../../redux/actions/menuActions";
import PdcsContainer from "../../containers/metier/pdcs/PdcsContainer";
import MenuMetier from "./Menu";

class Pdcs extends Component {
	componentDidMount() {
		this.props.setMenuTopIndex("metier");
		this.props.setMenuLeftIndex("basepdc");
		this.props.setMenuLeftContent(MenuMetier);
		this.props.setMenuLeftItemIndex("pdcs");
	}
	render() {
		return (
			<Fragment>
				<div className="p-page-title">
					{this.props.currentClientLabel} / Base PDC / Points de contact
				</div>
				<PdcsContainer {...this.props} />
			</Fragment>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		currentClientLabel: (state.currentClient || {}).label,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		setMenuTopIndex: index => {
			dispatch(setMenuTopIndex(index));
		},
		setMenuLeftContent: index => {
			dispatch(setMenuLeftContent(index));
		},
		setMenuLeftIndex: index => {
			dispatch(setMenuLeftIndex(index));
		},
		setMenuLeftItemIndex: index => {
			dispatch(setMenuLeftItemIndex(index));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Pdcs);



// WEBPACK FOOTER //
// src/pages/metier/Pdcs.js